export const EXITED_EMPLOYEES_BUCKET_ID = "__EXITED_EMPLOYEES__";
export const EXITED_EMPLOYEES_BUCKET_LABEL = "Exited employees";

export function isExitedEmployeesBucketId(id: string | null | undefined): boolean {
  return id === EXITED_EMPLOYEES_BUCKET_ID;
}
